// @ts-nocheck
import * as Types from '../../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../../../../assets/AssetPreview.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ChooseReplacementProjectItemDetailsQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type ChooseReplacementProjectItemDetailsQuery = { __typename?: 'Query', projectItem: { __typename?: 'ProjectItem', id: string, item: { __typename?: 'Item', id: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined } };

export type ChooseReplacementPossibleMaterialsQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
  filter: Types.MaterialVariantsFilter;
  orderBy?: Types.InputMaybe<Types.MaterialVariantOrderBy>;
}>;


export type ChooseReplacementPossibleMaterialsQuery = { __typename?: 'Query', materialVariants: { __typename?: 'MaterialVariantsPage', entities: Array<{ __typename?: 'MaterialVariant', id: string, displayName: string, hasAwardedCost: boolean, matchesPlaceholder: boolean, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } }> } };

export type ChooseReplacementPossibleMaterials_MaterialVariantFragment = { __typename?: 'MaterialVariant', id: string, displayName: string, hasAwardedCost: boolean, matchesPlaceholder: boolean, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } | null | undefined } | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined } };

export const ChooseReplacementPossibleMaterials_MaterialVariantFragmentDoc = gql`
    fragment ChooseReplacementPossibleMaterials_MaterialVariant on MaterialVariant {
  id
  displayName
  hasAwardedCost(projectItemId: $projectItemId)
  matchesPlaceholder(projectItemId: $projectItemId)
  featuredImage {
    id
    asset {
      ...AssetInfo
    }
  }
  listing {
    id
    name
    brand {
      id
      name
    }
  }
}
    ${AssetInfoFragmentDoc}`;
export const ChooseReplacementProjectItemDetailsDocument = gql`
    query ChooseReplacementProjectItemDetails($projectItemId: ID!) {
  projectItem(id: $projectItemId) {
    id
    item {
      id
    }
    materialVariant {
      id
    }
  }
}
    `;

/**
 * __useChooseReplacementProjectItemDetailsQuery__
 *
 * To run a query within a React component, call `useChooseReplacementProjectItemDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseReplacementProjectItemDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseReplacementProjectItemDetailsQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useChooseReplacementProjectItemDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables> & ({ variables: ChooseReplacementProjectItemDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>(ChooseReplacementProjectItemDetailsDocument, options);
      }
export function useChooseReplacementProjectItemDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>(ChooseReplacementProjectItemDetailsDocument, options);
        }
// @ts-ignore
export function useChooseReplacementProjectItemDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>;
export function useChooseReplacementProjectItemDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseReplacementProjectItemDetailsQuery | undefined, ChooseReplacementProjectItemDetailsQueryVariables>;
export function useChooseReplacementProjectItemDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>(ChooseReplacementProjectItemDetailsDocument, options);
        }
export type ChooseReplacementProjectItemDetailsQueryHookResult = ReturnType<typeof useChooseReplacementProjectItemDetailsQuery>;
export type ChooseReplacementProjectItemDetailsLazyQueryHookResult = ReturnType<typeof useChooseReplacementProjectItemDetailsLazyQuery>;
export type ChooseReplacementProjectItemDetailsSuspenseQueryHookResult = ReturnType<typeof useChooseReplacementProjectItemDetailsSuspenseQuery>;
export type ChooseReplacementProjectItemDetailsQueryResult = ApolloReactCommon.QueryResult<ChooseReplacementProjectItemDetailsQuery, ChooseReplacementProjectItemDetailsQueryVariables>;
export const ChooseReplacementPossibleMaterialsDocument = gql`
    query ChooseReplacementPossibleMaterials($projectItemId: ID!, $filter: MaterialVariantsFilter!, $orderBy: MaterialVariantOrderBy) {
  materialVariants(filter: $filter, orderBy: $orderBy) {
    entities {
      ...ChooseReplacementPossibleMaterials_MaterialVariant
    }
  }
}
    ${ChooseReplacementPossibleMaterials_MaterialVariantFragmentDoc}`;

/**
 * __useChooseReplacementPossibleMaterialsQuery__
 *
 * To run a query within a React component, call `useChooseReplacementPossibleMaterialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useChooseReplacementPossibleMaterialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChooseReplacementPossibleMaterialsQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useChooseReplacementPossibleMaterialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables> & ({ variables: ChooseReplacementPossibleMaterialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>(ChooseReplacementPossibleMaterialsDocument, options);
      }
export function useChooseReplacementPossibleMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>(ChooseReplacementPossibleMaterialsDocument, options);
        }
// @ts-ignore
export function useChooseReplacementPossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>;
export function useChooseReplacementPossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ChooseReplacementPossibleMaterialsQuery | undefined, ChooseReplacementPossibleMaterialsQueryVariables>;
export function useChooseReplacementPossibleMaterialsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>(ChooseReplacementPossibleMaterialsDocument, options);
        }
export type ChooseReplacementPossibleMaterialsQueryHookResult = ReturnType<typeof useChooseReplacementPossibleMaterialsQuery>;
export type ChooseReplacementPossibleMaterialsLazyQueryHookResult = ReturnType<typeof useChooseReplacementPossibleMaterialsLazyQuery>;
export type ChooseReplacementPossibleMaterialsSuspenseQueryHookResult = ReturnType<typeof useChooseReplacementPossibleMaterialsSuspenseQuery>;
export type ChooseReplacementPossibleMaterialsQueryResult = ApolloReactCommon.QueryResult<ChooseReplacementPossibleMaterialsQuery, ChooseReplacementPossibleMaterialsQueryVariables>;